import React, { useState, useEffect } from 'react';
import PlayerCard from './PlayerCard';
import './PlayerCard.css';

const API_HOST = process.env.REACT_APP_API_HOST;

function LeaderboardPreview() {
  const [leaderboard, setLeaderboard] = useState([]);

  useEffect(() => {
    async function fetchLeaderboard() {
      try {
        const res = await fetch(`${API_HOST}/public/leaderboard`);
        const data = await res.json();
        if (data.leaderboard) setLeaderboard(data.leaderboard);
        console.log('Leaderboard:', data.leaderboard);

      } catch (err) {
        console.error('Error fetching leaderboard:', err);
      }
    }

    fetchLeaderboard();
    const interval = setInterval(fetchLeaderboard, 30000);
    return () => clearInterval(interval);
  }, []);

  return (

      <div style={{ background: '#111', padding: '2rem', color: 'white' }}>
        {leaderboard.map(player => (
          <PlayerCard key={player.playerId} player={player} />
        ))}
      </div>    
  );
}

export default LeaderboardPreview;
